import React, { useEffect, useState, useContext } from 'react';
import { CheckSession, FormatCurrency, GetShoppingCart, KImageURL, DefaultImage, shopping_cart_session_id } from "../../GlobalScript";
import { ShoppingCartContext } from '../ShoppingCartContext';
import { useNavigate, useLocation } from "react-router-dom";
import useLocalStorage from "use-local-storage";
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import CloseButton from 'react-bootstrap/CloseButton';
import PulseLoader from "react-spinners/PulseLoader";
import $ from 'jquery';
import Cookies from 'js-cookie';
import * as Yup from 'yup';
import FooterDealer from '../../FooterDealer';

export default function CreditRequest() {
    const navigate = useNavigate();
    const [OrderType, setOrderType] = useState(null);
    const [DefaultShipTo, setDefaultShipTo] = useState(null);
    const [ShipTo, setShipTo] = useState(null);
    const [creditReason, setCreditReason] = useState('');
    const [InvoiceNum, setInvoiceNum] = useState('');
    const [SearchNum, setSearchNum] = useState('');
    const [RefID, setRefID] = useState('');
    const [KMCID, setKMCID] = useState('');
    const [knowSearchNum, setKnowSearchNum] = useState(true);
    const [itemNum, setItemNum] = useState('');
    const [Comments, setComments] = useState('');
    const [submit, setSubmit] = useState(false);
    const [canSubmit, setCanSubmit] = useState(false);
    const [SelectedReason, setSelectedReason] = useState(null);
    const [showReasonModal, setShowReasonModal] = useState(false);
    const [ReturnReasons, setReturnReasons] = useState(null);
    const [SelectedSKUs, setSelectedSKUs] = useState(new Map());
    const [AvailableItems, setAvailableItems] = useState(new Map());
    const [SKUComments, setSKUComments] = useState(new Map());
    const [Subtotal, setSubtotal] = useState(0);
    const [AllReturnResons, setAllReturnResons] = useState(0);
    const [DataToSubmit, setDataToSubmit] = useState(new Map());
    const [localReturnQty, setLocalReturnQty] = useState({});
    const [invoiceRequired, setInvoiceRequired] = useState(false);
    const [commentsRequired, setCommentsRequired] = useState(false);
    const [logNumberRequired, setLogNumberRequired] = useState(false);
    const [requirementMsg, setRequirementMsg] = useState('');
    const [OrderIDTop, setOrderIDTop] = useState(null);
    const [RefIDTop, setRefIDTop] = useState(null);
    const location = useLocation();
    const [pop, setPop] = useState(false);
    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false);
    const [duplicateInvoice, setDuplicateInvoice] = useState('');
    const { shoppingCart, setShoppingCart } = useContext(ShoppingCartContext);
    const [selectAll, setSelectAll] = useState(false);
    const [tempReason, setTempReason] = useState('');
    const [itemsTotal, setItemsTotal] = useState(0);
    const [itemsExchangeTotal, setItemsExchangeTotal] = useState(0);
    const [itemsExchangeAvailable, setItemsExchangeAvailable] = useState(0);
    const [exchangeOption, setExchangeOption] = useState('');
    const [exchange, setExchange] = useState(false);

    useEffect(() => {
        setShoppingCart(GetShoppingCart(shoppingCart));
        document.title = 'K-Dealer - Credit Request';
    }, [localStorage.getItem(shopping_cart_session_id)]);

    const handleReasonModalShow = (card) => {
        handleDetailsModalClose();
        setShowReasonModal(true);
        setSelectedReason(card);
        setCreditReason('');
        setRequirementMsg('');
        if (location.state && location.state.id && location.state.id !== '') {

        } else {
            setSearchNum('');
        }
    }

    const handleReasonModalClose = () => {
        setShowReasonModal(false);
        setKnowSearchNum(true);
        setSelectedReason(null);
    }
    const AddCredtRequestClick =() =>{
        setSearchNum('');
        handleDetailsModalShow();
    }
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const handleDetailsModalShow = () => {
        setShowDetailsModal(true);
    }
    const handleDetailsModalClose = () => {
        setShowDetailsModal(false);
    }

    const [showCreditModal, setShowCreditModal] = useState(false);
    const handleCreditModalClose = () => {
        setShowCreditModal(false);
    }

    const [errorMessage, setErrorMessage] = useState('');
    const [errorModal, setErrorModal] = useState(false);
    const handleShowErrorModal = (e) => {
        setErrorMessage(e);
        setErrorModal(true);
    }
    const handleCloseErrorModal = () => {
        setErrorModal(false);
        setErrorMessage('');
    }

    const [showExchangeModal, setShowExchangeModal] = useState(false);

    const handleExchangeModalOpen = () => {
        setShowExchangeModal(true);
    }
    const handleExchangeModalClose = () => {
        setShowExchangeModal(false);
    }

    const submitExchange = async () => {
        if (exchangeOption === '0' || exchangeOption === '1') {

            try {
                const arr = [];
                //let validated = true;
                DataToSubmit.forEach((innerMap, key) => {
                    innerMap.forEach((value, innerKey) => {
                        arr.push(value);
                    })
                });
                if (arr.length === 0) {
                    return;
                }

                const data = {
                    dealerID: dealerId,
                    items: arr,
                    comments: Comments,
                    discard: exchangeOption === "0"
                }
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-type': 'application/json'
                    },
                    body: JSON.stringify(data)
                };

                const resOrder = await fetch('kdealer/SubmitNewExchange', requestOptions);

                if (resOrder.status === 200) {
                    const res = await resOrder.json();
                    setOrderID(res.label);
                    setSubmit(true)
                }
                handleExchangeModalClose();
            } catch (e) {
                console.log(e);
                // handle your error
                return;
            }
        }
    }
    const submitItemExchange = () => {
        
        submitExchange();
    }

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleDeleteModalOpen = () => {
        setShowDeleteModal(true);
    }
    const handleDeleteModalClose = () => {
        setShowDeleteModal(false);
    }

    const DeleteSelectedItems = () => {
        const updatedOuterMap = new Map(SelectedSKUs);
        let count = 0;
        $('input:checkbox:checked').each(function () {
            const id = $(this).attr('id');
            const skuId = id.substring(5);

            let foundObj = null;
            let groupKey = null;

            for (const [key, innerMap] of SelectedSKUs.entries()) {
                const obj = innerMap.get(skuId);
                if (obj) {
                    foundObj = obj;
                    groupKey = key;
                    break;
                }
            }

            if (foundObj && groupKey) {
                const clonedMap = new Map(SelectedSKUs.get(groupKey));
                clonedMap.delete(skuId);
                updatedOuterMap.set(groupKey, clonedMap);
                count++;
            }

            for (const [groupKey, innerMap] of updatedOuterMap.entries()) {
                if (innerMap.size === 0) {
                    updatedOuterMap.delete(groupKey);
                }
            }
        })
        if (count > 0) {
            setSelectedSKUs(updatedOuterMap);
            setDataToSubmit(updatedOuterMap);
            $(':checkbox').prop('checked', false);
        }
        handleDeleteModalClose();
    }

    useEffect(() => {
        if (location && location.state) {
            if (location.state.id !== '') {
                setKMCID(location.state.id);
                setSearchNum(location.state.id);
                //handleCreditModalShow();
            }
            if (location.state.exchange) {
                //setCreditReason("69");
                setCreditReason('');
                setTempReason("Exchange");
                //setRequirementMsg("**Comment and Sales Invoice Required")
                setRequirementMsg("");
                setExchange(true);
                setCommentsRequired(false);
            }
        }       
    }, [location])

    useEffect(() => {
        if (location && location.state && location.state.exchange && SearchNum) {
            handleCreditModalShow();
        }
    }, [SearchNum, location])

    const handleChangeFinalCheckbox = async (e, data) => {
        //final step to select

        //let skuKey = data.sku;
        //let groupKey = (data.invoice + " " + data.refID).trim();
        //const map = DataToSubmit.get(groupKey);
        //if (e.target.checked) {
        //    map.set(skuKey, SelectedSKUs.get(groupKey).get(skuKey));
        //}
        //else {
        //    map.delete(skuKey);
        //}
        //DataToSubmit.set(groupKey, map);
        //setDataToSubmit(DataToSubmit);
    }

    useEffect(() => {
        console.log(SelectedSKUs);
    }, [SelectedSKUs])

    const handleSelectionChange = (e, data) => {
        const groupKey = GetGroupKey(data, itemNum, RefID, KMCID);
        let mapByGroup = new Map(SelectedSKUs);

        let obj = data;
        obj["comments"] = SKUComments.get((data.invoice + ' ' + data.refID + ' ' + data.sku).trim()) || "";
        obj["reason"] = creditReason ?? "";

        //if (mapByGroup.size > 0 && !mapByGroup.has(groupKey)) {
        //    $(`input:checkbox[value="${data.invoice + data.sku}"]`).prop('checked', false);
        //    setDuplicateInvoice("Only one invoice may be submitted at a time.");
        //    return;
        //}

        setDuplicateInvoice('');
        let temp = mapByGroup.get(groupKey);
        //let toExchangeTotal = itemsExchangeTotal;
        if (e.target.checked) {
            if (!temp || temp.size === 0) {
                temp = new Map();
            }
            temp.set(data.sku, obj);
            mapByGroup.set(groupKey, temp);
            //if (exchange === true) {
            //    //calculate total
            //    toExchangeTotal += data.unitPrice * data.returnQty;
            //}
        } else {
            if (temp) {
                temp.delete(data.sku);
                if (temp.size === 0) {
                    mapByGroup.delete(groupKey);
                }
            }
            //if (exchange === true) {
            //    //reset total
            //    toExchangeTotal -= data.unitPrice * data.returnQty;
            //}
           
        }
        //setItemsExchangeTotal(Math.max(toExchangeTotal, 0));
        //setItemsExchangeAvailable(Math.max(itemsTotal - toExchangeTotal, 0));
        setSelectedSKUs(mapByGroup);
        setDataToSubmit(mapByGroup);
    };

    const handleClickRequestNumber = () => {
        if (!OrderID || OrderID === '') {
            return;
        }
        navigate('/credithistory', { state: { id: OrderID } });
    }

    const GetReturnReasons = async () => {
        const response = await fetch("kdealer/GetCreditRequestReasons");
        if (response.status !== 200) {
            return;
        }
        const items = await response.json();
        setReturnReasons(items);
        console.log(items)
    }

    const GetAllReturnReasons = async () => {
        const response = await fetch("kdealer/GetAllReturnReasons");
        if (response.status !== 200) {
            return;
        }
        const items = await response.json();
        setAllReturnResons(items);
        console.log(items)
    }

    useEffect(() => {
        if (!ReturnReasons) {
            GetReturnReasons();
        }
    }, [ReturnReasons]);

    useEffect(() => {
        if (!AllReturnResons) {
            GetAllReturnReasons();
        }
    }, [AllReturnResons]);

    const handleCreditModalShow = () => {
        if (SearchNum || itemNum) {
            setKMCID('');
            setRefID('');
            setInvoiceNum('');
            setItemNum('');
            setAvailableItems(new Map());
            setSelectedSKUs(new Map());
            setDataToSubmit(new Map());
            let invoice = '', sku = '', ref = '', kmc = '';
            const isInvoice = IsInvoiceID(SearchNum);
            if (SearchNum) {
                //if (InvoiceRequired && isInvoice === false) {
                //    //handleShowErrorModal('Sales Invoice Number does not exist. Please enter a valid Sales Invoice Number.');
                //    handleShowErrorModal('Sales Invoice Number is required. Please enter a valid Sales Invoice Number.');
                //    return;
                //}
                //if (IsSESOrderID(SearchNum)) {
                //    setRefID(SearchNum);
                //    ref = SearchNum;
                //}
                if (isInvoice) {
                    setInvoiceNum(SearchNum);
                    invoice = SearchNum;
                } else if (IsKMCOrderID(SearchNum)) {
                    setKMCID(SearchNum);
                    kmc = SearchNum;
                }
            } else {
                setItemNum(itemNum);
                sku = itemNum;
            }
            handlePop();
            setSKUComments(new Map());
            CheckInvoiceItemRefID(invoice, sku, ref, kmc);
        } else {
            handleShowErrorModal('No eligible return qty for this item or Item / Sales Invoice Number does not exist. Please enter a valid Sales Invoice Number.');
        }
    };

    const GetGroupKey = (data, sku, ref, kmc) => {
        //let groupKey = '';
        //if (sku) {
        //    groupKey = data.orderID;
        //}
        //else if (ref || kmc) {
        //    groupKey = data.invoice;
        //}
        //return groupKey;
        return data.invoice
    }

    const CheckInvoiceItemRefID = async (invoice, sku, ref, kmc) => {
        try {
            setOrderIDTop(null);
            setRefIDTop(null);
            const data = {
                dealerID: dealerId,
                invoiceNum: invoice,
                itemNum: sku,
                refID: ref,
                orderID: kmc,
                reason: creditReason,
                exchange: exchange
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };

            const resOrder = await fetch('kdealer/CreditRequestItemValidation', requestOptions);

            if (resOrder.status === 200) {
                const res = await resOrder.json();
                const map = new Map();
                let groupKey = '';
                let orderIDtemp = null, kmcOrderIDtemp = null;
                setItemsTotal(res.orderedTotal);
                res.items.forEach((data) => {
                    groupKey = GetGroupKey(data, sku, ref, kmc);
                    if (map.has(groupKey)) {
                        const temp = map.get(groupKey);
                        temp.set(data.sku, data);
                    } else {
                        const temp = new Map();
                        temp.set(data.sku, data);
                        map.set(groupKey, temp)
                    }
                    if (invoice) {
                        if (!orderIDtemp && data.refID !== '') {
                            orderIDtemp = data.refID;
                        }
                        if (!kmcOrderIDtemp && data.orderID !== '') {
                            kmcOrderIDtemp = data.orderID;
                        }
                    }
                    else if (ref || kmc) {
                        if (!kmcOrderIDtemp && data.orderID !== '') {
                            kmcOrderIDtemp = data.orderID;
                        }
                        if (!orderIDtemp && data.refID !== '') {
                            orderIDtemp = data.refID;
                        }
                    }
                });
                if (orderIDtemp) {
                    setRefIDTop(orderIDtemp);
                }
                if (kmcOrderIDtemp) {
                    setOrderIDTop(kmcOrderIDtemp);
                }
                setAvailableItems(map);
                handleReasonModalClose();
                setShowCreditModal(true);
                handleClosePop();
                console.log(res);
            } else if (resOrder.status === 204) {
                if (InvoiceNum) {
                    handleShowErrorModal('No eligible return qty for this Sales Invoice Number. Please enter a valid Sales Invoice Number.');
                }
                else if (RefID) {
                    handleShowErrorModal('No eligible return qty for this Ref ID. Please enter a valid Ref ID.');
                }
                else if (KMCID) {
                    handleShowErrorModal('No eligible return qty for this Order ID. Please enter a valid Order ID.');
                }
                else {
                    handleShowErrorModal('No eligible return qty for this item. Please enter a valid Item Number.');
                }
            } else {
                //general error
                handleShowErrorModal('There was an error while attempting to retrieve the invoice details, please try again later.');
            }
            handleClosePop();
        } catch (e) {
            handleClosePop();
            console.log(e);
            // handle your error
            return;
        }
    }
    const SearchContent = (key) => {
        const isSESOrder = IsSESOrderID(key);
        const isInvoiceID = IsInvoiceID(key);
        const isKMCOrderID = IsKMCOrderID(key);
        let str = '';
        if (isSESOrder) {
            str = 'Ref: #';
        }
        else if (isInvoiceID) {
            str = 'INVOICE: #';
        }
        else if (isKMCOrderID) {
            str = 'Order: #';
        }
        else {
            str = 'Item: #';
        }
        str += key;
        return (
            <Col sm={12} key={"col1_" + key}>
                <h5 className="heading text-left mt-2">{str}</h5>
            </Col>
        );
    }
    useEffect(() => {
        const quantities = {};

        AvailableItems.forEach(element => {
            element.forEach(item => {
                const groupKey = (item.invoice  + item.refID  + item.sku).trim();
                quantities[groupKey] = item.returnQty;
            })
            //const groupKey = (element.invoice + ' ' + element.refID + ' ' + element.sku).trim();
            //quantities[groupKey] = element.returnQty;
        })

        setLocalReturnQty(quantities);
        console.log(localReturnQty);
    }, [AvailableItems])

    const handleReturnQtyChange = (e, data) => {
        //const id = e.target.id.replace('qty-', '');
        const input = e.target.value;
        const groupKey = (data.invoice  + data.refID  + data.sku).trim();

        if ((parseInt(input) >= 0) || (input === '')) {
            setLocalReturnQty(prev => ({
                ...prev,
                [groupKey]: parseInt(input),
            }));
        }
        /*console.log(localReturnQty);*/
    }

    const handleReturnQtyBlur = (e, data) => {
        //const id = e.target.id.replace('qty-', '');
        const input = e.target.value;
        const key = (data.invoice  + data.refID  + data.sku).trim();
        const outerMapKey = GetGroupKey(data, itemNum, RefID, KMCID);
        const outerMap = AvailableItems.get(outerMapKey);
        const item = outerMap ? outerMap.get(data.sku) : null;

        if (input === '' || parseInt(input) <= 0 || parseInt(input) > data.avlQty) {
            /*console.log(localReturnQty);*/
            setLocalReturnQty((prev) => ({
                ...prev,
                [key]: item && item.returnQty ? item.retrunQty : 1,
            }));
        } else {
            setLocalReturnQty(prev => ({
                ...prev,
                [key]: input,
            }));
        }
        //if (SelectedSKUs.has(outerMapKey)) {
        //    let map = SelectedSKUs.get(outerMapKey);
        //    if (map && map.has(data.sku)) {
        //        const obj = map.get(data.sku);
        //        obj.returnQty = localReturnQty[(obj.invoice + obj.refID + obj.sku).trim()];
        //        map.set(data.sku, obj);
        //        SelectedSKUs.set(outerMapKey, map);
        //    }

        //}
    }

    const [dealerId, setDealerId] = useState('');

    //const LoadOrderType = async () => {
    //    try {
    //        const response = await fetch("kdealer/GetOrderType");
    //        if (response.status !== 200) {
    //            return;
    //        }
    //        const ordType = await response.json();
    //        setOrderType(ordType);
    //    }
    //    catch (e) {
    //        console.log(e);
    //        return;
    //    }
    //}

    const LoadShipTo = async () => {
        try {
            CheckSession();
            const cookieValue = Cookies.get('user');
            const user = JSON.parse(cookieValue);
            setDealerId(user.dealerID);
            const response = await fetch("kdealer/GetDefaultShipTo/" + user.dealerID);
            if (response.status !== 200) {
                return;
            }
            const add = await response.json();
            setDefaultShipTo(add);
            setShipTo(add);
        }
        catch (e) {
            console.log(e);
            return;
        }
    }

    //useEffect(() => {
    //    if (!OrderType) {
    //        LoadOrderType();
    //    }
    //}, [OrderType])

    useEffect(() => {
        if (!ShipTo) {
            LoadShipTo();
        }
    }, [ShipTo])

    const IsSESOrderID =(val)=> {
        return val.startsWith('KDL') || val.startsWith('KCN');
    }

    const IsInvoiceID = (val) => {
        return val.startsWith('P00');
    }

    const IsKMCOrderID = (val) => {
        return isNaN(parseInt('val', 10))
    }

    const applyReasonSettings = (val, desc) => {
        setCreditReason(val);
        setTempReason(desc);

        for (let i = 0; i < SelectedReason.options.length; i++) {
            if (SelectedReason.options[i].key === val) {
                setInvoiceRequired(SelectedReason.options[i].invoice);
                setCommentsRequired(SelectedReason.options[i].comments);
                setLogNumberRequired(SelectedReason.options[i].logNumber);
                if (SelectedReason.options[i].invoice && SelectedReason.options[i].comments) {
                    setRequirementMsg("**Comment and Sales Invoice Required");
                } else if (SelectedReason.options[i].invoice) {
                    setRequirementMsg("***Sales Invoice Required");
                } else if (SelectedReason.options[i].comments) {
                    let str = "";
                    if (SelectedReason.options[i].desc.indexOf("Work/Function") > -1) {
                        str = "If installed, file as a Warranty Claim, not an RFC. ";
                    }
                    str += "**Comment Required";
                    setRequirementMsg(str);
                } else if (SelectedReason.options[i].logNumber) {
                    setRequirementMsg("**Log Number Required");
                } else {
                    setRequirementMsg('');
                }
                break;
            }
        }
    }

    const handleChangeReason = (event) => {
        const val = event.target.value.trim();
        const desc = event.target.options[event.target.selectedIndex].text;
        applyReasonSettings(val, desc)
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        const val = value.trim();
        //if (name === 'creditReason') {
        //    setCreditReason(val);
        //    setInvoiceRequired(val === '59' || val === '60' || val === '61' || val === '62' || val === '69');
        //} else
            if (name === 'SearchNum') {
            setSearchNum(val);
        } else if (name === 'invoiceNum-checkbox') {
            setKnowSearchNum(!knowSearchNum);
            setKMCID('');
            setRefID('');
            setInvoiceNum('');
            setItemNum('');
        } else if (name === 'itemNum') {
            setItemNum(val);
        } else if (name === 'comments') {
            setComments(val);
        } else if (name === 'dealerId') {
            setDealerId(val);
        } else if (name === 'RefID') {
            setRefID(val);
        }
    };

    const [oktosubmit, setoktosubmit] = useState(true);
    const [OrderID, setOrderID] = useState('');

    const handleExchangeContinue = () => {
        let validated = true;
        let toExchangeTotal = 0;
        $('input[type="checkbox"][id^="check"]:checked').each(function () {
            const id = this.id.substring(5);
            const tdElement = document.getElementById("price-" + id);
            const price = tdElement.textContent.replace('$', '');
            let qty = $('#qty-' + id).val();
            toExchangeTotal += Number(price) * parseInt(qty); 
        });
        if (!validated) {
            return;
        }
        setItemsExchangeTotal(Math.max(toExchangeTotal, 0));
        setItemsExchangeAvailable(Math.max(itemsTotal - toExchangeTotal, 0));
        setShowCreditModal(false);
        handleExchangeModalOpen();
    }

    const handleCreditModalContinue = () => {
        //let total = 0;
        //SelectedSKUs.forEach((innerMap, key) => {
        //    innerMap.forEach((value, innerKey) => {
        //        total += value.returnQty * value.unitPrice
        //    });
        //});
        //setSubtotal(total);
        let validated = true;
        
        $('input[type="checkbox"][id^="check"]:checked').each(function () {
            const id = this.id.substring(5);
            if ($('#comments' + id).val().trim().length === 0 && commentsRequired === true) {
                validated = false;
                $('#comments' + id).addClass("is-invalid");
            }
            else {
                $('#comments' + id).removeClass("is-invalid");
            }
          
        });
       
        //arr.forEach((obj, key) => {
        //    const id = obj.id.substring(5);
        //    if ($('#' + id).val().length === 0) {
        //        validated = false;
        //    }
        //});
        if (!validated) {
            return;
        }

        //if (commentsRequired && )
        UpdateTotlal();
        setoktosubmit(true);
        setShowCreditModal(false);

        setCreditReason('');
        setTempReason('');
        setCanSubmit(true);
        //setCreditReason('');
    }
    const UpdateTotlal = () => {
        if (!localReturnQty) {
            return;
        }
        let total = 0;
        const tempMap = new Map();
        SelectedSKUs.forEach((innerMap, key) => {
            innerMap.forEach((value, innerKey) => {
                const outerMapKey = GetGroupKey(value, itemNum, RefID, KMCID);
                if (SelectedSKUs.has(outerMapKey)) {
                    let map = SelectedSKUs.get(outerMapKey);
                    if (map && map.has(value.sku)) {
                        const obj = map.get(value.sku);
                        obj.returnQty = localReturnQty[(obj.invoice + obj.refID + obj.sku).trim()];
                        map.set(value.sku, obj);
                        tempMap.set(outerMapKey, map);
                    }

                }
                total += value.returnQty * value.unitPrice
            });
        });
        setSubtotal(total);
        setSelectedSKUs(tempMap);
    }

    useEffect(() => {
        UpdateTotlal();
    }, [localReturnQty])

    const handleDemoItemComments = (e, data) => {
        const groupKey = GetGroupKey(data, itemNum, RefID, KMCID);

        let mapByGroup = new Map(SelectedSKUs);
        let temp = mapByGroup.get(groupKey);

        if (e !== '') {
            if (!temp || temp.size === 0) {
                temp = new Map();
            }
            temp.set(data.sku, data);
            mapByGroup.set(groupKey, temp);
        } else {
            if (temp) {
                temp.delete(data.sku);
                if (temp.size === 0) {
                    mapByGroup.delete(groupKey);
                }
            }
        }
        setSelectedSKUs(mapByGroup);

        if (SelectedSKUs.has(groupKey)) {
            let map = SelectedSKUs.get(groupKey);
            if (map && map.has(data.sku)) {
                const obj = map.get(data.sku);
                obj["comments"] = e.target.value;
                map.set(data.sku, obj);
                SelectedSKUs.set(groupKey, map);
            }
        }

        setSKUComments((new Map(SKUComments)).set((data.invoice  + data.refID  + data.sku).trim(), e.target.value));
    };

    const allRequiredCommentsPresent = () => {
        if (!commentsRequired) return true;

        const allItems = Array.from(AvailableItems.entries())
            .flatMap(([key, valueArray]) => Array.from(valueArray.values()));

        const selectedItems = allItems.filter(value => {
            const groupKey = GetGroupKey(value, itemNum, RefID, KMCID);
            return SelectedSKUs.has(groupKey) &&
                SelectedSKUs.get(groupKey)?.has(value.sku);
        });

        if (selectedItems.length === 0) return false;

        return selectedItems.every(value => {
            const itemKey = (value.invoice + value.refID + value.sku).trim();
            const comment = SKUComments.get(itemKey);
            return comment && comment.trim().length > 0;
        });
    };

    //const InvoiceRequired = () => {
    //    return (creditReason === '59' || creditReason === '60' || creditReason === '61' || creditReason === '62' || creditReason === '69')
    //}

    const SubmitCreditRequest = async () => {
        try {
            const arr = [];
            let validated = true;
            DataToSubmit.forEach((innerMap, key) => {
                innerMap.forEach((value, innerKey) => {
                    arr.push(value);
                    //validation for comments
                    const id = 'comments' + value.invoice + value.refID + value.sku;
                    if (commentsRequired && value.comments.trim() === "")
                    {
                        //comments required
                        validated = false;
                       
                        $('#' + id).addClass("is-invalid");
                    }
                    else {
                        $('#' + id).removeClass("is-invalid");
                    }
                })
            });
            if (validated === false) {
                return;
            }
            if (arr.length === 0) {
                return;
            }         
            
            const data = {
                dealerID: dealerId,
                items: arr,
                comments: Comments
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };

            const resOrder = await fetch('kdealer/SubmitNewCROrder', requestOptions);

            if (resOrder.status === 200) {
                const res = await resOrder.json();
                setOrderID(res.label);
                setSubmit(true)
            }
        } catch (e) {
            console.log(e);
            // handle your error
            return;
        }
    }
    //end

    const handleSelectAll = () => {
        const newSelected = new Map();

        if (selectAll) {
            handleUnselectAll();
        } else {
            for (const [invoice, items] of AvailableItems.entries()) {
                const groupKey = GetGroupKey({ invoice }, itemNum, RefID, KMCID);
                const itemMap = new Map();

                for (const item of items.values()) {
                    const obj = {
                        ...item,
                        comments: SKUComments.get(`${item.invoice} ${item.refID} ${item.sku}`.trim()) || "",
                        reason: creditReason ?? ""
                    };
                    itemMap.set(item.sku, obj);
                }

                newSelected.set(groupKey, itemMap);
            }

            setSelectedSKUs(newSelected);
            setDataToSubmit(newSelected);
            setSelectAll(true);
        }
    }

    const handleUnselectAll = () => {
        setSelectedSKUs(new Map());
        setDataToSubmit(new Map());
        setSelectAll(false);
    };

    useEffect(() => {
        console.log(AvailableItems);
    }, [AvailableItems])

    return (
        <>
            <Container className="checkout-container main-container" style={{ minHeight: '53vh' }}>

                <Row className="help-title-row checkout-title-row">
                    <Col className="help-center-title checkout-title">
                        <h1 className="heading help-heading">CREDIT REQUEST FORM</h1>
                    </Col>
                    <Col className="checkout-title-under">
                    </Col>
                </Row>

                <Row className="dealer-section mb-3">
                    <Col md={12}>
                        {!submit ?
                            <>
                                <Card className="mb-3">
                                    <Card.Body>
                                        <Row>
                                            <Col sm={12} className="m-t-sm">
                                                <Card.Title className="vertical-line heading" role="heading">CREDIT REQUEST DETAILS</Card.Title>

                                                {!canSubmit ?
                                                    <>
                                                        <Row>
                                                            <Col sm={12}>
                                                                <p className="bold mt-2">Please select a reason for your return</p>
                                                            </Col>
                                                        </Row>

                                                        <Row>
                                                            <Col></Col>
                                                            <Col sm={10}>
                                                                <Row>
                                                                    {ReturnReasons && ReturnReasons.map((card) => (
                                                                        <Col sm={4} key={card.id}>
                                                                            <Card className="product-card credit-form-card clickable" onClick={() => handleReasonModalShow(card)}>
                                                                                <div className="green-border-bottom card-img-holder">
                                                                                    <img src={card.image} alt={card.alt} className="" />
                                                                                </div>
                                                                                <Card.Body>
                                                                                    <Row>
                                                                                        <Col sm={12} className="text-center">
                                                                                            <h5>{card.title}</h5>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </Card.Body>
                                                                            </Card>
                                                                        </Col>
                                                                    ))}
                                                                </Row>
                                                            </Col>
                                                            <Col></Col>
                                                        </Row>
                                                    </>
                                                    :
                                                    <>
                                                        {SelectedSKUs &&
                                                            <>
                                                                <Row>
                                                                    <Col sm={3}>
                                                                        <Table bordered className="table-spacing mb-0">
                                                                            <tbody>
                                                                                <tr>
                                                                                    {InvoiceNum &&
                                                                                        <td className="bold gray-bg">
                                                                                            INVOICE: #{InvoiceNum}
                                                                                        </td>
                                                                                    }
                                                                                    {/*{RefIDTop &&*/}
                                                                                    {/*    <td className="bold gray-bg">*/}
                                                                                    {/*        REF ID: #{RefIDTop}*/}
                                                                                    {/*    </td>*/}
                                                                                    {/*}*/}
                                                                                    {OrderIDTop &&
                                                                                        <td className="bold gray-bg">
                                                                                            ORDER ID: #{OrderIDTop}
                                                                                        </td>
                                                                                    }
                                                                                </tr>
                                                                            </tbody>
                                                                        </Table>
                                                                    </Col>
                                                                    <Col sm={9} className="text-right" key='detailcol'>
                                                                        <Button variant="secondary" onClick={AddCredtRequestClick} >
                                                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                            </svg>
                                                                            ADD CREDIT REQUEST
                                                                        </Button>
                                                                    </Col>
                                                                </Row>

                                                                <Row>
                                                                    {Array.from(SelectedSKUs.entries()).map(([key, valueArray]) => (
                                                                        <React.Fragment key={key}>
                                                                            {key && SearchContent(key)}                                               
                                                                            <Col sm={12} className="order-table" key={"col2_" + key}>
                                                                                <Table hover responsive key={"tbl" + key}>
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th width="5%">
                                                                                                <DropdownButton
                                                                                                    variant="light"
                                                                                                    title="Actions"
                                                                                                    id="actions-dropdown"
                                                                                                    className="mt-2 mb-2 dropdown-actions"
                                                                                                >
                                                                                                    <Dropdown.Item onClick={handleDeleteModalOpen} ><span className="svg-holder"><img src="../../../Images/cancelled-inactive.svg" alt="Delete" /> Delete</span></Dropdown.Item>
                                                                                                </DropdownButton>
                                                                                            </th>
                                                                                            <th>IMAGE</th>
                                                                                            <th>DETAILS</th>
                                                                                            <th>AVAIL QTY <br /> TO RETURN</th>
                                                                                            <th width="7%">RETURN <br /> QTY</th>
                                                                                            <th>PRICE</th>
                                                                                            <th width="28%">REASON AND <br /> COMMENT</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {Array.from(valueArray.values()).map((value, index) => (
                                                                                            <tr className="" key={key + value.sku}>
                                                                                                <td>
                                                                                                    <Form.Check type="checkbox" name="return_items" aria-label='Return Item' id={'check' + value.invoice + value.refID + value.sku} value={value.sku}
                                                                                                        onChange={(e) => handleChangeFinalCheckbox(e, value)} defaultChecked={false} />
                                                                                                </td>
                                                                                                {/*  <td className="table-img"><img src={value.img} alt="Product" className="item-image"></img></td>*/}
                                                                                                <td className="table-img">
                                                                                                    <img src={KImageURL(value.sku, value.img)}
                                                                                                        onError={({ currentTarget }) => {
                                                                                                            currentTarget.onerror = null;
                                                                                                            currentTarget.src = DefaultImage;
                                                                                                        }}
                                                                                                        alt="Product"
                                                                                                        className="item-image">
                                                                                                    </img> </td>
                                                                                                <td className="text-left">
                                                                                                    {/*{value.invoice && <p className="green-text">Invoice: #{value.invoice}</p>}*/}
                                                                                                    <p>{value.desc}</p>
                                                                                                    <p className="mb-0">Part #: {value.sku}</p>
                                                                                                </td>
                                                                                                <td>{value.avlQty}</td>
                                                                                                <td>
                                                                                                    <Form.Control
                                                                                                        type="number"
                                                                                                        id={`qty-${value.invoice + value.refID + value.sku}`}
                                                                                                        aria-describedby="Return Quantity"
                                                                                                        className={'form-control small-text-field'}
                                                                                                        onChange={(e) => handleReturnQtyChange(e, value)}
                                                                                                        onBlur={(e) => handleReturnQtyBlur(e, value)}
                                                                                                        value={localReturnQty[(value.invoice + value.refID + value.sku).trim()] ?? value.returnQty}
                                                                                                    />
                                                                                                </td>
                                                                                                <td>{FormatCurrency(value.unitPrice)}</td>
                                                                                                <td>
                                                                                                    <FloatingLabel label="Credit Request Reason" className="mb-2">
                                                                                                        <Form.Select aria-label="Credit Request Reasons" value={value.reason} name="ItemReason" disabled>
                                                                                                            {/*<option value={''}>Select a Credit Request Reason</option>*/}
                                                                                                            {AllReturnResons.map((itm) => (
                                                                                                                <option key={"all_" + itm.value} value={itm.value}>{itm.label}*</option> //here
                                                                                                            ))}
                                                                                                        </Form.Select>
                                                                                                    </FloatingLabel>

                                                                                                    <p className="bold text-left">{requirementMsg}</p>

                                                                                                    <FloatingLabel label={"Leave a comment" + (commentsRequired === true? "*" : "")}>
                                                                                                        <Form.Control
                                                                                                            id={'comments' + value.invoice + value.refID +value.sku}
                                                                                                            as="textarea"
                                                                                                            name="comments"
                                                                                                            value={value.comments}
                                                                                                            placeholder={"Leave a comment" + (commentsRequired === true? "*" : "")}
                                                                                                            maxLength="200"
                                                                                                            onChange={(e) => handleDemoItemComments(e, value)}
                                                                                                        />
                                                                                                    </FloatingLabel>
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))}
                                                                                    </tbody>
                                                                                </Table>
                                                                            </Col>
                                                                        </React.Fragment>
                                                                    ))}

                                                                </Row>
                                                            </>
                                                        }
                                                    </>
                                                }
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>

                                {canSubmit &&
                                    <Row className="d-flex">
                                        <Col sm={8} className="mb-5">
                                            <Card className="mb-4 h-100">
                                                <Card.Body>                                                    
                                                    <Row>
                                                        <Col sm={6}>
                                                            <Card.Title className="vertical-line heading" role="heading">CREDIT TO</Card.Title>
                                                            {ShipTo &&
                                                                <p className="m-t-md">{ShipTo.firstName} <br />
                                                                    {ShipTo.address} <br />
                                                                    {ShipTo.cityStateZip} <br />
                                                                    {ShipTo.countryCode}
                                                                </p>
                                                            }
                                                        </Col>
                                                        <Col sm={6}>
                                                            <Card.Title className="vertical-line heading" role="heading">COMMENTS</Card.Title>
                                                            <FloatingLabel label="Leave a comment">
                                                                <Form.Control
                                                                    id={'comments-dealer'}
                                                                    as="textarea"
                                                                    name="comments"
                                                                    placeholder="Leave a comment"
                                                                    style={{ height: '100px' }}
                                                                    maxLength="200"
                                                                    onChange={handleChange}
                                                                    className="m-t-md"
                                                                />
                                                            </FloatingLabel>
                                                        </Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                        <Col sm={4} className="mb-5">
                                            <Card className="summary-card mb-0">
                                                <Card.Body>
                                                    <Row className="title-group summary-title keep-layout checkout-title-row">
                                                        <Col className="checkout-title">
                                                            <Card.Title className="vertical-line heading" role="heading">CREDIT SUMMARY</Card.Title>
                                                            {/*<Card.Title className="heading" role="heading">CREDIT SUMMARY</Card.Title>*/}
                                                        </Col>
                                                        {/*<Col className="checkout-title-under"></Col>*/}
                                                    </Row>
                                                    <Row className="keep-layout">
                                                        <Col lg={6} md={8} sm={6}>
                                                            <p>Credit Subtotal</p>
                                                        </Col>
                                                        <Col lg={6} md={4} sm={6}>
                                                            <p className="right-text heading" id="creditSubtotal">{FormatCurrency(Subtotal)}</p>
                                                        </Col>
                                                    </Row>
                                                    <hr></hr>
                                                    <Row className="title-group summary-title keep-layout">
                                                        <Col sm={6}>
                                                            <Card.Title className="heading" role="heading">TOTAL</Card.Title>
                                                        </Col>
                                                        <Col sm={6}>
                                                            <Card.Title className="right-text heading">{FormatCurrency(Subtotal)}</Card.Title>
                                                        </Col>
                                                    </Row>
                                                    <hr></hr>
                                                    <Row className="text-right">
                                                        <Col>
                                                            <Button variant="primary" className="m-t-sm" onClick={SubmitCreditRequest} disabled={!oktosubmit} >
                                                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                </svg>
                                                                SUBMIT
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>    
                                }
                            </>
                            :
                            <>
                                <Card>
                                    <Card.Body>
                                        <Row>
                                            <Col className="text-center">
                                                <h1 className="vertical-line heading confirmation-heading">THANK YOU FOR YOUR CREDIT REQUEST!</h1>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={12} className="text-center mb-4">
                                                <h3 className="heading order-confirmation confirmation-heading">YOUR CREDIT REQUEST NUMBER IS <span className="underline green-text" onClick={() => handleClickRequestNumber()}>{OrderID}</span></h3>
                                                <p>You will recieve an email with your credit request confirmation!</p>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={6} className="text-right">
                                                <Button variant="secondary" className="" onClick={() => window.location.href = "/credithistory"}>
                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                    </svg>
                                                    CREDIT REQUEST HISTORY
                                                </Button>
                                            </Col>
                                            <Col sm={6} className="text-left">
                                                <Button controlid='btnContinue' variant="primary" className="submit" onClick={() => window.location.href = "/dealerhome"}>
                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                    </svg>
                                                    HOMEPAGE
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </>
                        }
                    </Col>
                </Row>
            </Container>

            <FooterDealer />

            <Modal show={showDetailsModal} onHide={handleDetailsModalClose} size="lg" dialogClassName="dealer-section" centered>
                <Modal.Header closeButton>
                    <Modal.Title>CREDIT REQUEST DETAILS</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>

                <Modal.Body>
                    {ReturnReasons &&
                        <>
                            <Row>
                                <Col sm={12}>
                                    <p className="bold mt-2">Please select a reason for your return</p>
                                </Col>
                            </Row>
                            <Row>
                                {ReturnReasons.map((card) => (
                                    <Col sm={4} key={card.id}>
                                        <Card className="product-card credit-form-card clickable" onClick={() => handleReasonModalShow(card)}>
                                            <div className="green-border-bottom card-img-holder">
                                                <img src={card.image} alt={card.alt} className="" />
                                            </div>
                                            <Card.Body>
                                                <Row>
                                                    <Col sm={12} className="text-center">
                                                        <h5>{card.title}</h5>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </>
                    }
                </Modal.Body>
            </Modal>

            <Modal show={showReasonModal} onHide={handleReasonModalClose} size="lg" dialogClassName="dealer-section" centered style={errorModal && { zIndex: 100 }}>
                <Modal.Header closeButton>
                    <Modal.Title>CREDIT REQUEST DETAILS</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>

                <Modal.Body>
                    {SelectedReason &&
                        <>
                            <Row>
                                <Col sm={4}>
                                    <div className="green-border padding-extra mb-3">
                                        <div className="card-img-holder modal-img-holder mb-3">
                                            <img src={SelectedReason.image} alt={SelectedReason.alt} className="" />
                                        </div>
                                        <h5>{SelectedReason.title}</h5>
                                    </div>
                                    {/*<Button variant="secondary" onClick={handleReasonModalClose} >*/}
                                    {/*    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">*/}
                                    {/*        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />*/}
                                    {/*    </svg>*/}
                                    {/*    CHANGE*/}
                                    {/*</Button>*/}
                                </Col>

                                <Col sm={8}>
                                    <p className="bold mt-2 text-left">Tell us a little more about this return</p>
                                    <Form.Select aria-label="Credit Request Reasons" onChange={handleChangeReason} value={creditReason} name="creditReason" >
                                        <option value={''}>Select a Credit Request Reason</option>
                                        {SelectedReason.options.map((option, index) => (
                                            <option key={"reason" + option.key} value={option.key}>{option.desc}</option>
                                        ))}
                                    </Form.Select>
                                    <p className="bold mt-2 text-left">{requirementMsg}</p>                               
                                </Col>
                            </Row>

                        {creditReason !== '' && 
                            <Row className="m-t-md">
                                <Col sm={6}>
                                    <FloatingLabel controlId="floatingInvoice" label={"Sales Invoice Number / Order ID" + (invoiceRequired === true ? "*" : "")} className="mb-3">
                                        <Form.Control type="" placeholder={"Sales Invoice Number / Order ID" + (invoiceRequired === true ? "*" : "")} value={SearchNum} onChange={handleChange} className="form-control" name="SearchNum" disabled={!knowSearchNum} />
                                    </FloatingLabel>
                                    {invoiceRequired === false && <Form.Check
                                        type={'checkbox'}
                                        id={'invoiceNum-checkbox'}
                                        label={'I do not know my Invoice Number'}
                                        name="invoiceNum-checkbox"
                                        onChange={handleChange}
                                        value={!knowSearchNum}
                                    />}
                                       
                                </Col>
                                {invoiceRequired === false && <Col sm={5}>
                                    <FloatingLabel controlId="floatingItemNum" label="Item Number" className="mb-3">
                                        <Form.Control type="" placeholder="Item Number" value={itemNum} onChange={handleChange} className="form-control" name="itemNum" disabled={knowSearchNum} />
                                    </FloatingLabel>
                                </Col>}
                                  
                                    <Col>
                                    <Button variant="primary" className="m-t-sm" disabled={!SearchNum && !itemNum} onClick={() => handleCreditModalShow()}>
                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                            </svg>
                                            SUBMIT
                                        </Button>
                                    </Col>
                                </Row>
                            }
                        </>
                    }
                </Modal.Body>
            </Modal>

            <Modal show={showCreditModal} onHide={handleCreditModalClose} size="lg" dialogClassName="modal-90w dealer-section" scrollable>
                <Modal.Header closeButton>
                    <Modal.Title>{exchange ? 'EXCHANGE' : 'CREDIT REQUEST DETAILS'}</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>

                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                            <Row>
                                <Col sm={4}>
                                    <Table bordered className="table-spacing mb-0">
                                        <tbody>
                                            <tr>
                                                {InvoiceNum &&
                                                    <td className="bold gray-bg">
                                                        INVOICE: #{InvoiceNum}
                                                    </td>
                                                }
                                                {/*{RefIDTop &&*/}
                                                {/*    <td className="bold gray-bg">*/}
                                                {/*        REF ID: #{RefIDTop}*/}
                                                {/*    </td>*/}
                                                {/*}*/}
                                                {OrderIDTop &&
                                                    <td className="bold gray-bg">
                                                        ORDER ID: #{OrderIDTop}
                                                    </td>
                                                }
                                            </tr>
                                        </tbody>
                                    </Table>

                                    <p className="text-left padding-left-extra-md">
                                        Reason: <span className="bold">{tempReason}</span>
                                    </p>
                                    <p className="bold text-left padding-left-extra-md">{requirementMsg}</p>

                                    <Row>
                                        <Col sm={12} className="text-left padding-left-extra-lg">
                                            <Form.Check
                                                type="checkbox"
                                                name="selectAll"
                                                aria-label='Select All'
                                                label="Select All"
                                                checked={selectAll}
                                                onChange={() => handleSelectAll()}
                                            />
                                        </Col>
                                    </Row>
                                </Col>

                                {exchange === true &&
                                    <Col sm={4}>
                                        <Card className="summary-card mb-0 h-100 text-left">
                                            <Card.Body>
                                                <Row className="title-group summary-title keep-layout checkout-title-row">
                                                    <Col className="checkout-title">
                                                        <Card.Title className="vertical-line heading" role="heading">EXCHANGE DETAILS</Card.Title>
                                                    </Col>
                                                </Row>
                                                <Row className="keep-layout">
                                                    <Col lg={8} md={8} sm={6}>
                                                        <p>Items Ordered Total:</p>
                                                    </Col>
                                                    <Col lg={4} md={4} sm={6}>
                                                        <p className="right-text heading">{FormatCurrency(itemsTotal)}</p>
                                                    </Col>
                                                </Row>
                                                <Row className="keep-layout">
                                                    <Col lg={8} md={8} sm={6}>
                                                        <p>Items to Exchange Total:</p>
                                                    </Col>
                                                    <Col lg={4} md={4} sm={6}>
                                                        <p className="right-text heading">{FormatCurrency(itemsExchangeTotal)}</p>
                                                    </Col>
                                                </Row>
                                                <Row className="keep-layout">
                                                    <Col lg={8} md={8} sm={6}>
                                                        <p>Avail Items to Exchange Total:</p>
                                                    </Col>
                                                    <Col lg={4} md={4} sm={6}>
                                                        <p className="right-text heading">{FormatCurrency(itemsExchangeAvailable)}</p>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                }
                            </Row>

                            {Array.from(AvailableItems.entries()).map(([key, valueArray]) => (
                                <React.Fragment key={key}>
                                    <Col sm={12} className="order-table" key={"col2_" + key}>
                                        {key && SearchContent(key)}
                                        <Table hover responsive key={"tbl" + key}>
                                            <thead>
                                                <tr>
                                                    <th width="5%">                                                                
                                                    </th>
                                                    <th>IMAGE</th>
                                                    <th width="15%">DETAILS</th>
                                                    <th>AVAIL QTY <br /> TO {exchange ? 'EXCHANGE' : 'RETURN'}</th>
                                                    <th width="7%">{exchange ? 'EXCHANGE' : 'RETURN'} QTY</th>
                                                    <th>PRICE</th>
                                                    <th>REASON AND <br /> COMMENT</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array.from(valueArray.values()).map((value, index) => (

                                                    <tr className="" key={key + value.sku}>
                                                        <td>
                                                            <Form.Check
                                                                type="checkbox"
                                                                name="return_items"
                                                                aria-label='Return Item'
                                                                id={'check' + value.invoice + value.refID + value.sku}
                                                                value={value.invoice + value.sku}
                                                                checked={SelectedSKUs.has(GetGroupKey(value, itemNum, RefID, KMCID)) &&
                                                                    SelectedSKUs.get(GetGroupKey(value, itemNum, RefID, KMCID))?.has(value.sku)}
                                                                onChange={(e) => handleSelectionChange(e, value)}
                                                            />
                                                        </td>
                                                        <td className="table-img">
                                                            <img src={KImageURL(value.sku, value.img)}
                                                                onError={({ currentTarget }) => {
                                                                    currentTarget.onerror = null;
                                                                    currentTarget.src = DefaultImage;
                                                                }}
                                                                alt="Product"
                                                                className="item-image">
                                                            </img>
                                                        </td>
                                                        <td className="text-left">
                                                            {/*{value.invoice && <p className="green-text">Invoice: #{value.invoice}</p>}*/}
                                                            <p>{value.desc}</p>
                                                            <p className="mb-0">Part #: {value.sku}</p>
                                                        </td>
                                                        <td>{value.avlQty}</td>
                                                        <td id=''>
                                                            <Form.Control
                                                                type="number"
                                                                id={`qty-${value.invoice + value.refID + value.sku}`}
                                                                aria-describedby="Order Quantity"
                                                                className={'form-control small-text-field'}
                                                                onChange={(e) => handleReturnQtyChange(e, value)}
                                                                onBlur={(e) => handleReturnQtyBlur(e, value)}
                                                                value={localReturnQty[(value.invoice  + value.refID  + value.sku).trim()] ?? value.returnQty}
                                                            />
                                                        </td>
                                                        <td id={`price-${value.invoice + value.refID + value.sku}`}>{FormatCurrency(value.unitPrice)}</td>
                                                        <td>
                                                            <FloatingLabel label={"Leave a comment" + (commentsRequired === true ? "*" : "")}>
                                                                <Form.Control
                                                                    key={"td" + index}
                                                                    id={'comments' + value.invoice + value.refID + value.sku}
                                                                    as="textarea"
                                                                    name="comments"
                                                                    placeholder={"Leave a comment" + (commentsRequired === true? "*" : "")}
                                                                    style={{ height: '100px' }}
                                                                    maxLength="200"
                                                                    onChange={(e)=>handleDemoItemComments(e, value)}
                                                                />
                                                            </FloatingLabel>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </Col>
                                </React.Fragment>
                            ))}

                        </Col>
                    </Row>
                </Modal.Body>

                <Modal.Footer className="text-right border-top">
                    <Row>
                        <Col sm={12}>
                            <p>{duplicateInvoice}</p>
                        </Col>
                    </Row>
                    <Button variant="primary" onClick={exchange === true ? handleExchangeContinue : handleCreditModalContinue} disabled={!SelectedSKUs || SelectedSKUs.size === 0 || !allRequiredCommentsPresent()}>
                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                        </svg>
                        CONTINUE
                    </Button>
                </Modal.Footer>

            </Modal>

            <Modal className="loader-div" id="loader" show={pop} onHide={handleClosePop} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>

            <Modal show={showDeleteModal} onHide={handleDeleteModalClose} dialogClassName="dealer-section" centered>
                <Modal.Header closeButton>
                    <Modal.Title>DELETE ITEM</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                            <p>Are you sure you want to remove this item from your credit request?</p>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer style={{ display: 'block' }}>
                    <Row>
                        <Col sm={6} className="text-right">
                            <Button variant="secondary" onClick={handleDeleteModalClose}>
                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                </svg>
                                CANCEL
                            </Button>
                        </Col>
                        <Col sm={6} className="text-left">
                            <Button variant="primary" onClick={DeleteSelectedItems}>
                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                </svg>
                                REMOVE
                            </Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>

            <Modal show={showExchangeModal} onHide={handleExchangeModalClose} size="lg" dialogClassName="modal-90w dealer-section" centered scrollable>
                <Modal.Header closeButton>
                    <Modal.Title>ITEM EXCHANGE CONFIRMATION</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={5}>
                            <Table bordered className="table-spacing mb-0">
                                <tbody>
                                    <tr>
                                        {InvoiceNum &&
                                            <td className="bold gray-bg">
                                                INVOICE: #{InvoiceNum}
                                            </td>
                                        }
                                        {OrderIDTop &&
                                            <td className="bold gray-bg">
                                                ORDER ID: #{OrderIDTop}
                                            </td>
                                        }
                                    </tr>
                                </tbody>
                            </Table>

                            <p className="text-left padding-left-extra-md">
                                Reason: <span className="bold">{tempReason}</span>
                            </p>
                            <p className="bold text-left padding-left-extra-md">{requirementMsg}</p>
                        </Col>
                        
                        <Col sm={5}>
                            <Card className="summary-card mb-0 h-100 text-left">
                                <Card.Body>
                                    <Row className="title-group summary-title keep-layout checkout-title-row">
                                        <Col className="checkout-title">
                                            <Card.Title className="vertical-line heading" role="heading">EXCHANGE DETAILS</Card.Title>
                                        </Col>
                                    </Row>
                                    <Row className="keep-layout">
                                        <Col lg={8} md={8} sm={6}>
                                            <p>Items Ordered Total:</p>
                                        </Col>
                                        <Col lg={4} md={4} sm={6}>
                                            <p className="right-text heading">{FormatCurrency(itemsTotal)}</p>
                                        </Col>
                                    </Row>
                                    <Row className="keep-layout">
                                        <Col lg={8} md={8} sm={6}>
                                            <p>Items to Exchange Total:</p>
                                        </Col>
                                        <Col lg={4} md={4} sm={6}>
                                            <p className="right-text heading">{FormatCurrency(itemsExchangeTotal)}</p>
                                        </Col>
                                    </Row>
                                    <Row className="keep-layout">
                                        <Col lg={8} md={8} sm={6}>
                                            <p>Avail Items to Exchange Total:</p>
                                        </Col>
                                        <Col lg={4} md={4} sm={6}>
                                            <p className="right-text heading">{FormatCurrency(itemsExchangeAvailable)}</p>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12} className="text-left mt-3">
                            <ul>
                                <li>All items returned to KMC on the Exchange program must be new, identified by item number, and in resaleable condition.</li>
                                <li>Accessories must also be in the original package.</li>
                                <li>The approved item number and returned item number must be the same item. Substitutions are not accepted.</li>
                            </ul>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={2}></Col>

                        <Col sm={8}>
                            <Row>
                                <Col sm={12} className="mt-3 text-left black-bg">
                                    <div className="padding-extra">
                                        <h4 className="white-text">Please indicate your instruction to KMC for handling items that do not meet the above criteria</h4>
                                    </div>
                                </Col>

                                <Col sm={6} className={exchangeOption === '0' ? "green-border text-left gray-bg" : "text-left gray-bg"}>
                                    <div className="padding-extra">
                                        <Form.Check
                                            type='radio'
                                            label='Discard items that are not resaleable with no credit issued for items.'
                                            name="exchangeOption"
                                            value='0'
                                            onChange={() => setExchangeOption('0')}
                                            checked={exchangeOption === '0'}
                                        />
                                    </div>
                                </Col>

                                <Col sm={6} className={exchangeOption === '1' ? "green-border text-left gray-bg" : "text-left gray-bg"}>
                                    <div className="padding-extra">
                                        <Form.Check
                                            type='radio'
                                            label='Return items that are not resaleable to my dealership and bill return freight to my Parts Account.'
                                            name="exchangeOption"
                                            value='1'
                                            onChange={() => setExchangeOption('1')}
                                            checked={exchangeOption === '1'}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>

                        <Col sm={2}></Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col sm={12} className="text-center">
                            <Button variant="primary" onClick={submitItemExchange}>
                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                </svg>
                                SUBMIT
                            </Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>

            <Modal show={errorModal} onHide={handleCloseErrorModal} dialogClassName="dealer-section" centered>
                <Modal.Header closeButton>
                    <Modal.Title>ALERT</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                            <p>{errorMessage}</p>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    );
}